import { EntityDiffSchema } from '../../types';
import { Campaign } from 'src/components-bl/EmailMarketing/types/campaign';

type EmailMarketingCampaignsDiffSchema = {
  [key: string]: {
    displayName: string;
    getDisplayName: (change: any, oldEntity: Campaign, newEntity: Campaign) => string;
  };
};

export const emailMarketingCampaignsDiffsSchema: EntityDiffSchema<
  EmailMarketingCampaignsDiffSchema,
  Campaign
> = {
  'widgetMaker.productCard.*': {
    displayName: 'Widget Maker Product Card Field',
    getDisplayName: (change, oldEntity, newEntity) => {
      const path = change.valuePath ?? '';
      const fieldName = path.split('.').pop() ?? '';

      const oldCards = oldEntity?.widgetMaker?.productCard ?? [];
      const newCards = newEntity?.widgetMaker?.productCard ?? [];

      const matchedIndex = oldCards.findIndex(
        (_, i) => newCards[i]?.[fieldName] === change.newValue
      );

      if (matchedIndex === -1 && newCards.length > oldCards.length) {
        const newCardIndex = newCards.length - 1;
        return `Widget Maker Product Card ${newCardIndex} - New Card`;
      }

      return `Widget Maker Product Card ${matchedIndex + 1} ${fieldName}`;
    },
  },
};
